import { InterstitialDrawer } from "./InterstitialDrawer";

export default InterstitialDrawer;
